import FilterBar from "../ui/FilterBar";
import FilterSelect from "../ui/FilterSelect";
import { useAuthStore } from "../../store/authStore";
import { SHOW_VOICE_AND_META } from "../../config/features";

const toUniqueFilterOptions = (items = []) => {
  return Array.from(
    new Set(
      items
        .map((item) => (typeof item === "string" ? item.trim() : item))
        .filter((item) => item && item !== "All")
    )
  );

};

export default function LeadsFilters({
  filterAgent,
  setFilterAgent,
  filterProperties,
  setFilterProperties,
  filterCategory,
  setFilterCategory,
  filterSource,
  setFilterSource,
  filterIntent,
  setFilterIntent,
  sortDate,
  setSortDate,
  agents = [],
  properties = [],
}) {
  const { role } = useAuthStore();
  const isAdmin = role === "admin";

  // console.log(" agents", agents)
  // console.log("properties",properties)

  return (
    <FilterBar>
      {isAdmin && (
      <FilterSelect
        label="Agent"
        value={filterAgent}
        onChange={(e) => setFilterAgent(e.target.value)}
        options={[
          { label: "All Agents", value: "All" },
          ...agents,
        ]}
      />
      )}

      <FilterSelect
        label="Property"
        value={filterProperties}
        onChange={(e) => setFilterProperties(e.target.value)}
        options={[
          { label: "All Properties", value: "All" },
          ...properties,
        ]}
      />

      <FilterSelect
        label="Category"
        value={filterCategory}
        onChange={(e) => setFilterCategory(e.target.value)}
        options={[
          { label: "All Categories", value: "All" },
          { label: "Hot", value: "Hot" },
          { label: "Warm", value: "Warm" },
          { label: "Cold", value: "Cold" },
        ]}
      />

      <FilterSelect
        label="Source"
        value={filterSource}
        onChange={(e) => setFilterSource(e.target.value)}
        options={[
                 { label: "All Sources", value: "All" },
                 { label: "Chat", value: "Chat" },
                 { label: "Activity", value: "Activity" },
                 { label: "Call", value: "Call" },
                 ...(SHOW_VOICE_AND_META
                   ? [
                       { label: "Facebook", value: "Facebook" },
                       { label: "Instagram", value: "Instagram" },
                       { label: "WhatsApp", value: "WhatsApp" },
                     ]
                   : []),
               ]}
      />

      <FilterSelect
        label="Intent"
        value={filterIntent}
        onChange={(e) => setFilterIntent(e.target.value)}
        options={[
          { label: "All Intents", value: "All" },
          {
            label: "Site Visit",
            value: "site_visit_request",
          },
          {
            label: "Callback",
            value: "callback_request",
          },
        ]}
      />

      <FilterSelect
        label="Sort By"
        value={sortDate}
        onChange={(e) => setSortDate(e.target.value)}
        options={[
          { label: "Latest", value: "Latest" },
          { label: "Oldest", value: "Oldest" },
        ]}
      />
    </FilterBar>
  );
}
